var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-64 rounded-lg flex flex-col border-4 bg-blue-600"},[_c('div',{staticClass:"my-auto ",domProps:{"innerHTML":_vm._s(_vm.$t('banner'))}})])}
var staticRenderFns = []

export { render, staticRenderFns }